import React, { useEffect, useState } from "react";
import { ViewLayout } from "components/ViewLayout/ViewLayout";
import { Tab, Tabs } from "react-bootstrap";
import { push, addParam, removeParam, getQueryString, setParam } from "api/search/filterUrlMaker";
import { Events } from "pages/Events/Events";
import { _t } from "app/i18n/i18n";
import { Coverage } from "../../Coverage/Coverage";
import { useCoverageData } from "../../Coverage/data/CoverageDataProvider";
import { useJSFetchPublications } from "../../redesign/publications/api/direct/useJSFetchPublications";
import { useCreateSearchRequest } from "../../redesign/publications/api/searchRequest/useCreateSearchRequest";
import SubscriptionsModal from "../../../components/Subscriptions/SubscriptionsModal/SubscriptionsModal";

const onTabChange = (key) => {
  const queryParams = getQueryString();
  const filteredParams = Object.fromEntries(Object.entries(queryParams).filter(([param]) => param === "Analyst"));

  if (key === "videos") {
    push(addParam("contentType.en", "Webcast", filteredParams));
  } else {
    push(key === "events" ? filteredParams : removeParam("contentType.en", "Webcast", filteredParams));
  }

  push(addParam("Tab", key));
};

export function AnalystProfileTabs({ profile, isMobile = false }) {
  const { rows } = useCoverageData();
  const hasEquityCoverage = rows?.length > 0;
  const queryParams = getQueryString();

  useEffect(() => {
    const hasEquityTimeout = setTimeout(() => {
      if (!queryParams.Tab) {
        if (hasEquityCoverage) {
          push(setParam("Tab", "Equity"));
        } else {
          push(setParam("Tab", "publications"));
        }
      }
    }, 1500);
    setDefaultActiveTab(queryParams.Tab);

    return () => clearTimeout(hasEquityTimeout);
  }, [hasEquityCoverage]);

  const [defaultActiveTab, setDefaultActiveTab] = useState("");

  return (
    <section className="mx-3 mt-5">
      <hr />
      <Tabs
        activeKey={defaultActiveTab}
        className={isMobile ? "mb-2 flex-md-row " : "mb-2 flex-column flex-md-row"}
        onSelect={(key) => {
          setDefaultActiveTab(key);
          onTabChange(key);
        }}
      >
        {hasEquityCoverage && (
          <Tab eventKey="Equity" title={_t("Equity Coverage")}>
            <Coverage showFilters={false} />
          </Tab>
        )}
        <Tab eventKey="publications" title={_t("Publications")}>
          <Publications />
        </Tab>
        <Tab eventKey="events" title={_t("Events")} tabClassName={profile.eventCount > 0 ? "" : "d-none"}>
          <Events showHeader={false} />
        </Tab>
        <Tab eventKey="videos" title={_t("Webcasts")} tabClassName={profile.videoCount > 0 ? "" : "d-none"}>
          <Publications />
        </Tab>
      </Tabs>
      <hr />
      <SubscriptionsModal modalTitle={_t("Subscriptions for Nomura Research")} />
    </section>
  );
}

function Publications() {
  const searchRequest = useCreateSearchRequest();
  const data = useJSFetchPublications(searchRequest);
  const publications = data?.[0];

  return <ViewLayout publications={publications} data={data} hideAds />;
}
